import React, { useState } from "react";
import img from "../../icons/amenity.jpg";
import Ac from "../../amentiesImages/Ac.png";
import Breakfast from "../../amentiesImages/Breakfast.png";
import Breakfast2 from "../../amentiesImages/Breakfast2.png";
import Commute from "../../amentiesImages/Commute.png";
import Frontdesk from "../../amentiesImages/Frontdesk.png";
import Gym from "../../amentiesImages/Gym.png";
import HomeService from "../../amentiesImages/RoomService.png";
import Laundry from "../../amentiesImages/Laundry.png";
import Luggae2 from "../../amentiesImages/Business.png";
import Luggage from "../../amentiesImages/Luggage.png";
import Minibar from "../../amentiesImages/RoomService.png";
import Parking from "../../amentiesImages/Parking.png";
import Pet from "../../amentiesImages/Pet.png";
import Spa from "../../amentiesImages/Spa.png";
import Swimming from "../../amentiesImages/Swimming.png";
import Wheelchair from "../../amentiesImages/Wheelchair.png";
import Wifi from "../../amentiesImages/Wifi.png";
import Wine from "../../amentiesImages/Bar.png";
import Tv from "../../amentiesImages/Tv.png";

const iconMap = {
  "Free Wi-Fi": Wifi,
  "Complimentary Breakfast": Breakfast2,
  "Room Service": HomeService,
  "Fitness Center/Gym": Gym,
  "Swimming Pool": Swimming,
  "Business Center": Luggae2,
  "On-Site Restaurant/Bar": Wine,
  "Concierge Service": Breakfast,
  "Parking (Free or Paid)": Parking,
  "Air Conditioning/Heating": Ac,
  "24-Hour Front Desk": Frontdesk,
  "Laundry Services": Laundry,
  "Airport Shuttle Service": Commute,
  "Pet-Friendly Accommodations": Pet,
  "Mini-Bar": Minibar,
  "Spa/Wellness Center": Spa,
  "Cable/Satellite TV": Tv,
  "Luggage Storage": Luggage,
  "Wheelchair Accessibility": Wheelchair,
};

// Helper function to add spaces around slashes for better text wrapping
const formatAmenityName = (name) => {
  return name.replace(/\//g, ' / ');
};

// Helper function to determine if text is likely single line (heuristic approach)
const isSingleLineText = (text) => {
  // Heuristic: text under 25 characters is likely single line at current text size
  return text.length <= 25;
};

const BottomSheet = ({ amenities, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end z-50">
      <div
        className="bg-white w-full md:w-2/3 lg:w-1/2 max-h-[60vh] rounded-t-lg overflow-y-auto p-4"
        style={{ height: "60vh" }}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">All Amenities</h2>
          <button
            onClick={onClose}
            className="text-gray-500 text-lg focus:outline-none"
          >
            ✕
          </button>
        </div>

        {/* ENHANCED GRID WITH CONDITIONAL ALIGNMENT */}
        <div className="grid grid-cols-2 gap-x-4 gap-y-6">
          {amenities.map(
            (amenity, index) =>
              amenity.enabled && (
                <div 
                  key={index} 
                  className={`flex space-x-3 min-w-0 max-w-full pr-2 ${
                    isSingleLineText(amenity.name) ? 'items-center' : 'items-start'
                  }`}
                >
                  <img
                    src={amenity.enabled ? amenity.image : ""}
                    alt={amenity.name}
                    className="w-10 h-10 object-contain flex-shrink-0"
                  />
                  <span 
                    className="text-gray-800 text-sm leading-snug flex-1"
                    style={{
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      wordBreak: 'break-word',
                      overflowWrap: 'break-word',
                      hyphens: 'auto',
                      lineHeight: '1.4'
                    }}
                  >
                    {formatAmenityName(amenity.name)}
                  </span>
                </div>
              ),
          )}
        </div>
      </div>
    </div>
  );
};

export default BottomSheet;
